'use strict';
import React, { Component } from 'react'
var FormatMessage = require('react-globalize').FormatMessage;

export default class FraudAlerts extends Component {

  constructor(props) {
    super(props);
  }

  render () {
    return (
      <div className="container">
        <div className="row text-justify">

          {
            this.props.locale == "es" ?
            <div className="col-md-12" style={{padding:25}}>
              <div className="row">
                <div className="col-md-9">
                  <p>
                    En Barri proteger a nuestros clientes es una prioridad, por lo que cada día 
                    estamos fortaleciendo nuestros esfuerzos de cumplimiento de protección al 
                    consumidor. Realizamos entrenamientos dirigidos a nuestros consumidores, 
                    asociados estratégicos, y empleados para que puedan tomar medidas de protección 
                    sobre los diferentes escenarios de fraude.
                  </p>
                  <p>
                    El fraude es una industrial criminal, y desafortunadamente los servicios de 
                    transferencia de dinero es el medio comúnmente utilizado por estas personas 
                    para sus actividades ilegales con el fin de defraudar y dañar deliberadamente 
                    a los consumidores. Estos criminales tienen la habilidad de convencer a los 
                    consumidores para que les envíen dinero, sabiendo que no hay forma de recuperar 
                    el dinero una vez ha sido transferido.
                  </p>
                  <p>
                    La mejor manera de detenerlos es aprender cómo pueden intentar estafarnos, y en 
                    ese sentido hemos definido nuestro objetivo: el cual es mantener nuestros 
                    consumidores informados para evitar que se conviertan en víctimas de fraude. 
                  </p>
                  <p>
                    A continuación presentamos una lista de tipos de fraudes que han sido denunciados 
                    por nuestros clientes. Haga usted lo mismo, si usó Barri para transferir dinero 
                    como resultado de una estafa, denuncie en nuestra línea de Servicio de atención 
                    al cliente de Barri al 1-888-488-3201.
                  </p>
                </div>
                <div className="col-md-3">
                  <img className="img-responsive center-block" style={{height:"250px"}} src="img/alerta.png" alt="alert" />
                </div>
              </div>
              <div className="row" style={{marginTop:25}}>
                <div className="col-md-3">
                  <img className="img-responsive" src="img/alerta2_es.png" alt="alert" />
                </div>
                <div className="col-md-9">
                  <p style={{color:"red", textAlign:"center", fontWeight:"bold"}}>
                    Estafas de impostores de emergencia familiar.
                  </p>
                  <p>
                    Impostores que se hacen pasar por amigos o familiares en problemas 
                    para engañar a los consumidores para que les transfieran dinero. 
                  </p>
                  <p>
                    <i>
                    “Perdí mi cartera e identificación. Estoy varado — envíame dinero, por favor.”
                    “Tu nieto está detenido en prisión. Necesita dinero para la fianza de inmediato.”
                    </i>
                  </p>
                  <p>
                    Los estafadores tratan de engañarte para que pienses que un ser querido 
                    está en problemas. Llaman, envían mensajes de texto, emails o publican 
                    mensajes en los medios sociales sobre una supuesta emergencia de un 
                    familiar o amigo. Te piden que les envíes dinero de inmediato. Para 
                    que su historia parezca real, pueden presentarse como una persona 
                    con autoridad, como abogado u oficial de policía; y podrían tener 
                    o adivinar algunos hechos sobre tu ser querido. Estos impostores 
                    pueden insistir para que mantengas su pedido de dinero en secreto 
                    con el propósito de impedir que verifiques su historia y los identifiques 
                    como impostores. Pero independientemente del nivel de realidad o urgencia 
                    que pueda tener lo que te digan — es <a target="_blank"
                    href="https://www.consumer.ftc.gov/media/video-0117-family-emergency-imposter-scams">
                      <strong>una estafa.</strong>
                    </a>
                  </p>
                  <p style={{color:"red", textAlign:"center", fontWeight:"bold"}}>
                    Nunca envíes dinero a alguien que no conoces.
                  </p>
                </div>
              </div>
              <div className="row" style={{marginTop:25}}>
                <div className="col-md-9">
                  <p style={{color:"red", textAlign:"center", fontWeight:"bold"}}>
                    Estafas telefónicas amenazantes contra padres e inmigrantes.
                  </p>
                  <p>
                    Te realizan llamadas donde buscan engañarte, te amenazan al punto 
                    de asustarte para quitarte el dinero. 
                  </p>
                  <p>
                    <strong>La estafa telefónica de extorsión a los padres</strong>, comienza con alguien que 
                    te envía una foto de tu propio hijo por mensaje de texto— la foto podrían 
                    haberla sacado de internet, por ejemplo, de tu cuenta pública en las redes 
                    sociales. A veces, estos estafadores también envían fotos aterradoras, 
                    como imágenes de cuerpos descuartizados. En cualquiera de los casos, 
                    los mensajes vienen junto con una amenaza del estafador que dice que sabe 
                    dónde vives y que matará a tu familia si no le pagas. Si recibes una llamada 
                    como esta, antes de hacer cualquier otra cosa, denúnciala a tu departamento 
                    de policía local inmediatamente.
                  </p>
                  <p>
                    <strong>Estafa telefónica contra inmigrantes</strong>, comienza <a target="_blank"
                    href="https://www.consumer.ftc.gov/media/video-0117-family-emergency-imposter-scams">
                      <strong>como una llamada de un impostor</strong>
                      </a> que se hace pasar por alguien del Servicio de Inmigración y 
                    Control de Aduanas de EE.UU. (ICE). Con frecuencia, estos estafadores 
                    dicen que te están revocando tu estatus de inmigración y que la 
                    policía va en camino a arrestarte o deportarte — a menos que les 
                    pagues de inmediato.
                  </p>
                </div>
                <div className="col-md-3">
                  <img className="img-responsive" src="img/alerta3_es.jpg" alt="alert" />
                </div>
              </div>
              <div className="row" style={{marginTop:25}}>
                <div className="col-md-3">
                  <img className="img-responsive" src="img/alerta4_es.png" alt="alert" />
                </div>
                <div className="col-md-9">
                  <p style={{color:"red", textAlign:"center", fontWeight:"bold"}}>
                    Estafa:  Compras por Internet
                  </p>
                  <p>
                    Los estafadores utilizan sitios web o clasificados en línea 
                    para anunciar cualquier tipo de artículos, como mascotas, 
                    teléfonos móviles, y servicios que no existen. Tenga cuidado 
                    sal enviar dinero en respuesta a un anuncio en línea.
                  </p>
                  <p style={{color:"red", textAlign:"center", fontWeight:"bold", marginTop:15}}>
                    Estafa: Pagos por Anticipado
                  </p>
                  <p>
                    Los ladrones se hacen pasar por empresas auténticas y atraen a 
                    las víctimas a pagar honorarios en previsión de recibir algo de 
                    mayor valor, como un préstamo, tarjeta de crédito, suscripción, 
                    inversión o dinero de herencia. La víctima envía dinero al 
                    estafador utilizando un servicio de transferencia de dinero, pero 
                    luego no recibe nada a cambio. Estos préstamos, tarjetas de 
                    crédito, suscripciones, inversiones o sumas de herencia nunca 
                    existieron realmente. Y una vez que los estafadores obtienen su 
                    dinero, nunca se les vuelve a saber de ellos.
                  </p>
                </div>
              </div>
            </div> 
            
            :
            
            <div className="col-md-12" style={{padding:25}}>
              <div className="row">
                <div className="col-md-9">
                  <p>
                    At Barri protecting our customers is a priority, so every day we are 
                    strengthening our consumer protection compliance efforts. We conduct 
                    training aimed at our consumers, strategic partners, and employees so 
                    they can take protective measures on different fraud scenarios.
                  </p>
                  <p>
                    Fraud is a criminal industrialist, and unfortunately money transfer 
                    services are the most commonly used means by these people for their 
                    illegal activities in order to deliberately defraud and harm consumers. 
                    These criminals have the ability to convince consumers to send them 
                    money, knowing that there is no way to get the money back once it 
                    has been transferred.
                  </p>
                  <p>
                    The best way to stop them is to learn how they can try to scam us, 
                    and in that sense we have defined our goal: which is to keep our 
                    consumers informed to prevent them from creating victims of fraud.
                  </p>
                  <p>
                    Below is a list of types of frauds that have been reported by our 
                    customers. Do the same, if you used Barri to transfer money as a result 
                    of a scam, report to our Barri Customer Service line at 1-888-488-3201.
                  </p>
                </div>
                <div className="col-md-3">
                  <img className="img-responsive center-block" style={{height:"250px"}} src="img/alerta.png" alt="alert" />
                </div>
              </div>
              <div className="row" style={{marginTop:25}}>
                <div className="col-md-3">
                  <img className="img-responsive" src="img/alerta2_en.png" alt="alert" />
                </div>
                <div className="col-md-9">
                  <p style={{color:"red", textAlign:"center", fontWeight:"bold"}}>
                    Family Emergency Impostor Scams.
                  </p>
                  <p>
                    Impostors who pass as friends or family in trouble to trick 
                    consumers into transferring money to them.
                  </p>
                  <p>
                    <i>
                      "I lost my wallet and ID. I'm stranded — send me money, please."
                      "Your grandson is being held in prison. You need money for bail right away."
                    </i>
                  </p>
                  <p>
                    Scammers try to trick you into thinking a loved one is in trouble. 
                    Call, text, email, or post social media messages about an alleged 
                    emergency by a family member or friend. They ask you to send them 
                    money right away. To make your story look real, you can present yourself 
                    as a person with authority, as a lawyer or police officer; and they 
                    might have or guess some facts about your loved one. These impostors 
                    can insist that you keep your request for money secret in order to 
                    prevent you from verifying their history and identifying them as 
                    impostors. But no matter what level of reality or urgency you may 
                    have what you're told — it's <a target="_blank"
                    href="https://www.consumer.ftc.gov/media/video-0117-family-emergency-imposter-scams">
                      <strong>a scam.</strong>
                    </a>
                  </p>
                  <p style={{color:"red", textAlign:"center", fontWeight:"bold"}}>
                    Never send money to someone you haven't met.
                  </p>

                </div>
              </div>
              <div className="row" style={{marginTop:25}}>
                <div className="col-md-9">
                  <p style={{color:"red", textAlign:"center", fontWeight:"bold"}}>
                    Threatening phone scams against parents and immigrants
                  </p>
                  <p>
                    They make calls where they seek to trick you, threaten you to 
                    the point of scaring you to take your money.
                  </p>
                  <p>
                    <strong>The parent extortion phone scam</strong>, starts with someone 
                    who sends you a photo of your own child by text message—the photo 
                    might have been taken from the internet, for example, from your public 
                    social media account. Sometimes these scammers also send scary photos, 
                    such as images of quartered bodies. In either case, the messages come 
                    along with a scammer's threat that says he knows where you live and 
                    that he'll kill your family if you don't pay him. If you get a call 
                    like this, before you do anything else, report it to your local police 
                    department immediately.
                  </p>
                  <p>
                    <strong>Phone scam against immigrants</strong>, begins <a target="_blank"
                    href="https://www.consumer.ftc.gov/media/video-0117-family-emergency-imposter-scams">
                      <strong>as a call from an imposter</strong>
                    </a> impersonating someone from the U.S. Immigration and Customs 
                    Enforcement (ICE) Service. Often, these scammers say they're revoking 
                    your immigration status and that the police are on their way to arrest 
                    or deport you — unless you pay them right away.
                  </p>
                </div>
                <div className="col-md-3">
                  <img className="img-responsive" src="img/alerta3_en.jpg" alt="alert" />
                </div>
              </div>
              <div className="row" style={{marginTop:25}}>
                <div className="col-md-3">
                  <img className="img-responsive" src="img/alerta4_en.jpg" alt="alert" />
                </div>
                <div className="col-md-9">
                  <p style={{color:"red", textAlign:"center", fontWeight:"bold"}}>
                    Internet Purchase Scam
                  </p>
                  <p>
                    Scammers use websites or online classifieds to advertise items, 
                    such as pets, mobile phones, event tickets and cars, that don’t 
                    exist. Be careful when sending money in response to an online 
                    advertisement
                  </p>
                  <p style={{color:"red", textAlign:"center", fontWeight:"bold", marginTop:15}}>
                    Advanced Fee Scam
                  </p>
                  <p>
                    Thieves pose as authentic companies and lure victims into paying 
                    fees in anticipation of receiving something of greater value, like 
                    a loan, credit card, grant, investment or inheritance money. The 
                    victim sends money to the scammer using a money transfer service, 
                    but then receives nothing in return. These loans, credit cards, 
                    grants, investments or inheritance sums never actually existed. 
                    And once the scammers get their money, they are never heard from again.
                  </p>
                </div>
              </div>
            </div>
            
          }
        </div>
      </div>
    )
  }

}


// WEBPACK FOOTER //
// ./js/fraudAwareContent/fraudAlerts.js